export const GET_USER_ORGANIZATION = "GET_USER_ORGANIZATION"
export const GET_USER_ORGANIZATION_PENDING = "GET_USER_ORGANIZATION_PENDING"
export const GET_USER_ORGANIZATION_FAILED = "GET_USER_ORGANIZATION_REJECTED"
export const GET_USER_ORGANIZATION_FULFILLED = "GET_USER_ORGANIZATION_FULFILLED"

export const UPDATE_USER_ORGANIZATION = "UPDATE_USER_ORGANIZATION"
export const SAVE_USER_ORGANIZATION = "SAVE_USER_ORGANIZATION"

export const INVITE_USERS = "INVITE_USERS"
export const INVITE_USERS_PENDING = "INVITE_USERS_PENDING"
export const INVITE_USERS_FULFILLED = "INVITE_USERS_FULFILLED"
export const INVITE_USERS_FAILED = "INVITE_USERS_REJECTED"